import React, { useContext, useEffect } from "react";
import styles from "./Parallax.module.scss";
import PathContext from "../../context/path";
import { useRef } from 'react';
const Parallax = (props) => {
  const { factor } = props;
  const refWrap = useRef(null);
  const refInner = useRef(null);

  useEffect(() => {
    const wrap = refWrap.current;
    const inner = refInner.current;

    const scrollHandler = () =>{
      let offset = (wrap.getBoundingClientRect().top - window.innerHeight) * factor;
      inner.style.top = `${offset}px`;
    }
    scrollHandler();

    let options = {
      threshold: 0,
      rootMargin: '0% 0% 0% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.addEventListener('scroll', scrollHandler);
          window.addEventListener('resize', scrollHandler);
        } else {
          document.removeEventListener('scroll', scrollHandler);
          window.removeEventListener('resize', scrollHandler);
        }
      })
    }, options);
    observer.observe(wrap);
    return () => {
      observer.unobserve(wrap);
      document.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', scrollHandler);
    }
  }, []);
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.inner} ref={refInner}>
          {props.children}
        </div>
      </div>
    </>
  );

}

export default Parallax;
